export default "__VITE_ASSET__Hr72MSFG__"